export enum SceneDescriptionConstants {
  SET_SCENE_DESCRIPTION = 'sceneDescription/SET_SCENE_DESCRIPTION',
  SET_NUM_PTS_SCENE = 'sceneDescription/SET_NUM_PTS_SCENE',
  SET_FIRST_ON_SCENE = 'sceneDescription/SET_FIRST_ON_SCENE',
  SET_FIRST_ON_SCENE_PNNV = 'sceneDescription/SET_FIRST_ON_SCENE_PNNV',
  SET_LEVEL_CARE_PER_PROTOCOL = 'sceneDescription/SET_LEVEL_CARE_PER_PROTOCOL',
  SET_LEVEL_CARE_PER_PROTOCOL_PNNV = 'sceneDescription/SET_LEVEL_CARE_PER_PROTOCOL_PNNV',
  SET_PR_OTHER_AGENCIES = 'sceneDescription/SET_PR_OTHER_AGENCIES',
  SET_LAWNUM = 'sceneDescription/SET_LAWNUM',
  SET_FIRENUM = 'sceneDescription/SET_FIRENUM',
  SET_PR_DISASTER = 'sceneDescription/SET_PR_DISASTER',
  SET_PR_DISPO_INSTRUCTIONS = 'sceneDescription/SET_PR_DISPO_INSTRUCTIONS',
  SET_BELONGINGS = 'sceneDescription/SET_BELONGINGS',
  SET_PR_PT_MOVED_VIA = 'sceneDescription/SET_PR_PT_MOVED_VIA',
  SET_PR_PT_POSITION = 'sceneDescription/SET_PR_PT_POSITION',
  SET_PR_PT_MOVED_FROM = 'sceneDescription/SET_PR_PT_MOVED_FROM',
  SET_PR_TRANSPORT_ASSESS = 'sceneDescription/SET_PR_TRANSPORT_ASSESS',
  SET_STRETCHER_PURPOSE_DESCR = 'sceneDescription/SET_STRETCHER_PURPOSE_DESCR',
  SET_ACCORDIAN_OPEN = 'sceneDescription/SET_ACCORDIAN_OPEN',
  ADD_NEW_AGENCY = 'sceneDescription/ADD_NEW_AGENCY',
  REMOVE_AGENCY = 'sceneDescription/REMOVE_AGENCY',
  SET_OTHER_AGENCIES = 'sceneDescription/SET_OTHER_AGENCIES',
  SET_OTHER_AGENCY_NUMBER = 'sceneDescription/SET_OTHER_AGENCY_NUMBER',
  SET_OTHER_AGENCY_TYPE = 'sceneDescription/SET_OTHER_AGENCY_TYPE',
  SET_OTHER_AGENCY_NAME = 'sceneDescription/SET_OTHER_AGENCY_NAME',
  SET_OTHER_AGENCY_FIRST_ON_SCENE = 'sceneDescription/SET_OTHER_AGENCY_FIRST_ON_SCENE',
  SET_OTHER_AGENCY_FIRST_ON_SCENE_PNNV = 'sceneDescription/SET_OTHER_AGENCY_FIRST_ON_SCENE_PNNV',
  SET_CAD_COMMENTS = 'sceneDescription/SET_CAD_COMMENTS',
  DELETE_CAD_COMMENTS = 'sceneDescription/DELETE_CAD_COMMENTS',
  SET_TRANSFER_OF_CARE = 'sceneDescription/SET_TRANSFER_OF_CARE',
  SET_TRANSFER_OF_CARE_PNNV = 'sceneDescription/SET_TRANSFER_OF_CARE_PNNV',
  UPDATE_FIRST_ON_SCENE = 'sceneDescription/UPDATE_FIRST_ON_SCENE',
  CANCEL_FIRST_ON_SCENE_UPDATE = 'sceneDescription/CANCEL_FIRST_ON_SCENE_UPDATE',
  CLOSE_FIRST_ON_SCENE_MESSAGE = 'sceneDescription/CLOSE_FIRST_ON_SCENE_MESSAGE',
  SET_SCENE_DESCRIPTION_STATE = 'sceneDescription/SET_SCENE_DESCRIPTION_STATE',
  RESET_SCENE_DESCRIPTION_STATE = 'sceneDescription/RESET_SCENE_DESCRIPTION_STATE',
  SAVE_SCENE_DESCRIPTION_STATE = 'sceneDescription/SAVE_SCENE_DESCRIPTION_STATE',
}
